import MagicGrid from 'magic-grid';

window.MagicGrid = MagicGrid;
